{{ message() | transloco: translationParams() || {} }}

@if (errorMessage()) {
  <br />
  {{ errorMessage() }}
}
